import React, { useState, useEffect } from "react";
import { TableCell, TableRow } from "@material-ui/core";
import {
  ModalDeleteConfirm,
  IconButtonDatatable,
  TableCellDefault,
  TableWrapper,
} from "App/Component/ui";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import {
  FormTabAsuransi,
  headCells,
  STYLE_TAB_ASURANSI,
  RESET_STATE_ASURANSI,
  getAllAsuransi,
  deleteAsuransiById,
} from "./ui";

import { useDatatables } from "App/hooks";
import { scrollToTop } from "App/utils/helpers";
import { PencilIcon, TrashIcon } from "App/Assets";
import { FilterColumns, PrepareDataExport } from "../../../helpers";

export default function TabAsuransi() {
  const classes = STYLE_TAB_ASURANSI();
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [rows, setRows] = useState([]);
  const [formData, setFormData] = useState(RESET_STATE_ASURANSI);
  const [run, setRun] = useState(false);

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name"],
  });

  useEffect(() => {
    (async () => {
      const res = await getAllAsuransi();
      if (res) {
        setRows(res);
      }
    })();
  }, [run]);

  const setVal = (row) => {
    return setFormData({
      id: row?.id,
      name: row?.name,
      address: row?.address,
      phone: row?.phone,
      contactperson: row?.contactperson,
      insurance_type_id: row.insurance_type_id,

      cpaddress: row?.cpaddress,
      cpemail: row?.cpemail,
      cpphone: row?.cpphone,
      cpmobilephone: row?.cpmobilephone,
      harga_id: row?.harga_id,
      status: row?.status ? 1 : 0,
      remark: row?.remark,
      nama_virtual_account: row?.nama_virtual_account,
      no_virtual_account: row?.no_virtual_account,
      nama_bank: row?.nama_bank,
    });
  };

  const prepareHeaders = {
    id: "id",
    name: "nama_asuransi",
    nama_virtual_account: "nama_virtual_account",
    no_virtual_account: "no_virtual_account",
    nama_bank: "nama_bank",
    address: "alamat",
    phone: "no_telepon",
    contactperson: "nama_kp",
    cpphone: "no_telepon_kp",
    createdAt: "inserted_time:date",
    createdName: "inserted_by",
    updatedAt: "updated_time:date",
    updatedName: "updated_by",
  };
  const dataExport = PrepareDataExport(data, prepareHeaders);
  const headerExport = FilterColumns(dataExport);

  return (
    <div className={classes.root}>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() =>
            deleteAsuransiById(
              formData.id,
              () => setRun(!run),
              setShowModalDeleteConfirm,
              setFormData,
            )
          }
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <FormTabAsuransi
        formData={formData}
        setFormData={setFormData}
        run={() => setRun(!run)}
      />

      <div className="mt-2">
        <TableWrapper
          title="Daftar Asuransi"
          setQ={setQ}
          withAddButton={false}
          withExportButton={true}
          allData={dataExport}
          headers={headerExport}
          order={order}
          orderBy={orderBy}
          handleRequestSort={handleRequestSort}
          length={length}
          rows={rows}
          headCells={headCells}
          page={page}
          setPage={setPage}
          rowsPerPage={rowsPerPage}
          setRowsPerPage={setRowsPerPage}>
          {stableSort(data, getComparator(order, orderBy))
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, index) => {
              return (
                <TableRow
                  hover
                  tabIndex={-1}
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                  }}>
                  <TableCell
                    component="th"
                    scope="row"
                    padding="none"
                    align="center">
                    {index + 1}
                  </TableCell>

                  <TableCell
                    component="th"
                    scope="row"
                    padding="none"
                    align="center">
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "7px",
                      }}>
                      <IconButtonDatatable
                        onClick={() => {
                          setVal(row);
                          scrollToTop();
                        }}>
                        <PencilIcon />
                      </IconButtonDatatable>

                      <IconButtonDatatable
                        onClick={() => {
                          setFormData({
                            ...formData,
                            id: row?.id,
                          });
                          setShowModalDeleteConfirm(!showModalDeleteConfirm);
                        }}>
                        <TrashIcon />
                      </IconButtonDatatable>
                    </div>
                  </TableCell>

                  <TableCell align="left">{row?.id}</TableCell>
                  <TableCell align="left">{row?.name}</TableCell>
                  <TableCell align="center">{row?.status ? 'Aktif' : 'Tidak Aktif'}</TableCell>
                  <TableCell align='left'>{row?.nama_bank}</TableCell>
                  <TableCell align='left'>{row?.no_virtual_account}</TableCell>
                  <TableCell align='left'>{row?.nama_virtual_account}</TableCell>
                  <TableCell align="left">{row?.address}</TableCell>
                  <TableCell align="left">{row?.phone}</TableCell>
                  <TableCell align="left">{row?.contactperson}</TableCell>
                  <TableCell align="left">{row?.cpphone}</TableCell>
                  <TableCellDefault row={row} />
                </TableRow>
              );
            })}
        </TableWrapper>

        {/* <FormFilterAsuransi /> */}

        {/* <Grid
            container
            direction='row'
            justifyContent='flex-end'
            alignItems='center'>
            <MasterButton
              name={"Export"}
              outline={false}
              color={"warning"}
              type={"submit"}
              size={"md"}
              className='mt-2 mb-1'
            />
          </Grid> */}

        {/* <TableContainer className='custom-scrollbar'>
            <Table
              className={classes.table}
              aria-labelledby='tableTitle'
              size={"medium"}
              aria-label='enhanced table'>
              <TableHeader
                classes={classes}
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
                rowCount={length}
                headCells={headCells}
              />
              <TableBody>
                {stableSort(data, getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    return (
                      <TableRow
                        hover
                        tabIndex={-1}
                        key={index}
                        style={{
                          backgroundColor:
                            index % 2 === 0 ? "transparent" : "#fff",
                        }}>
                        <TableCell
                          component='th'
                          scope='row'
                          padding='none'
                          align='center'>
                          {index + 1}
                        </TableCell>

                        <TableCell
                          component='th'
                          scope='row'
                          padding='none'
                          align='center'>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "7px",
                            }}>
                            <IconButtonDatatable
                              onClick={() => {
                                setVal(row);
                                scrollToTop();
                              }}>
                              <PencilIcon />
                            </IconButtonDatatable>

                            <IconButtonDatatable
                              onClick={() => {
                                setFormData({
                                  ...formData,
                                  id: row?.id,
                                });
                                setShowModalDeleteConfirm(
                                  !showModalDeleteConfirm
                                );
                              }}>
                              <TrashIcon />
                            </IconButtonDatatable>
                          </div>
                        </TableCell>

                        <TableCell align='left'>{row?.id}</TableCell>
                        <TableCell align='left'>{row?.name}</TableCell>
                        <TableCell align='left'>{row?.address}</TableCell>
                        <TableCell align='left'>{row?.phone}</TableCell>
                        <TableCell align='left'>{row?.contactperson}</TableCell>
                        <TableCell align='left'>{row?.cpphone}</TableCell>
                        <TableCellDefault row={row} />
                      </TableRow>
                    );
                  })}
                {rows.length === 0 && (
                  <TableRow>
                    <TableCell align='center' colSpan={headCells.length}>
                      Tidak ada data
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <DatatablesFooter
            page={page}
            length={length}
            rowsPerPage={rowsPerPage}
            selectRows={[10, 20]}
            onPageChange={(page) => setPage(page - 1)}
            onSelectChange={(e) => setRowsPerPage(e.target.value)}
          /> */}
      </div>
    </div>
  );
}
